export default {
  cards: {
    table: {
      jenisUsaha: {
        content: {
          title: "Detail Usaha Ekonomi",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          showSaveAsImage: false,
          showTable: false,
          showDownloadTable: true,
          info: "#### Detail jenis usaha ekonomi yang dilakukan pondok pesantren",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Jenis Usaha",
              dataIndex: "jenis_usaha",
            },
            {
              title: "Jumlah",
              dataIndex: "total",
            },
          ],
          dataSource: [],
        },
      },
    },
  },
};
